export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-primary-500"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-accent-500"></div>
          </div>

          <div className="flex-1 relative z-10 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-500/20 text-primary-400 mb-4 whitespace-nowrap">
              即将上线
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              每日黑料 APP
            </h2>
            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-md mb-6">
              蹲坑摸鱼、通勤路上、睡前醒后——随时随地打开每日黑料APP，
              最新最热的瓜一个都不落下。推送提醒让你永远走在吃瓜第一线，
              离线缓存功能让你没网也能刷爆料。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-foreground-900 font-semibold text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 版本
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/10 text-background-50 font-medium text-sm rounded-lg border border-background-50/20 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 版本
              </a>
            </div>
            <p className="text-xs text-background-50/40 mt-4">
              APP 正在紧锣密鼓开发中，敬请期待！当前可通过手机浏览器访问获得完整体验。
            </p>
          </div>

          <div className="flex-1 relative z-10 flex justify-center">
            <div className="relative w-[220px] h-[440px] md:w-[260px] md:h-[520px] rounded-2xl overflow-hidden border-4 border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20themed%20mobile%20phone%20screen%20mockup%20showing%20abstract%20entertainment%20news%20feed%20interface%2C%20warm%20red%20crimson%20accents%20on%20dark%20background%2C%20modern%20clean%20UI%20design%20concept%2C%20editorial%20news%20app%20aesthetic%2C%20no%20readable%20text%20no%20faces%20no%20people%2C%20minimalist%20dark%20mode&width=300&height=600&seq=app-mockup-visual&orientation=portrait"
                alt="每日黑料APP移动端界面预览"
                onError={(e) => { const el = (e.currentTarget as HTMLElement); if (el.parentElement) el.parentElement.style.display = 'none'; }}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}